import React from 'react'
import styled from 'styled-components'

const SubTitle = ({ children }) => {
  return <El>{children}</El>
}

export default SubTitle

const El = styled.h2`
  color: ${props => props.theme.colors.white};
  font-weight: bold;
  ${props => props.theme.fontSizing(props.theme.font.subTitleSizes)};
  margin-bottom: 0.6em;
  margin-top: 0px;
`
